import { c as i } from "./math.CqRL4S9t.js";
function m(o) {
  const t = i(o), n = 50, a = 100, s = 20;
  return `hsl(${t % 360}, ${t % (a - n) + n}%, ${t % (55 - s) + s}%)`;
}
export {
  m as g
};
